import React, { PureComponent } from "react";

import { Loader } from 'react-loaders';
import { moneyFormat } from "./format";
import MoneyTable, { populateKeys } from "./MoneyTable";
import TwoPanels from "./TwoPanels";
import Text from "./Text";
import FormulaTable from "./FormulaTable";
import { batchRequest } from '../../api/ApiService';
import styled from 'styled-components';
import Auth from '../../routes/Auth';

const Wrapper = styled.div`
  .loader {
    display: inline-block;
    margin-top: 20px;
    margin-left: 20px;
  }

  .loader .loader-inner div {
    border-color: #36507e;
  }
`;

class BalanceSheet extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      equitiesIssuanceLte: 0,
      stockRepurchasedSharesLte: 0,
    };
  }

  componentDidMount() {
    const { round } = this.props;

    let teamEquitiesUrl = `${process.env.REACT_APP_API_URL}team/equities/?round_lte=${round}`;
    let teamStockRepurchased = `${process.env.REACT_APP_API_URL}team/stock_repurchased/?round_lte=${round}`;

    if (Auth.getPosition() === 'Instructor') {
      teamEquitiesUrl += `&team_id=${Auth.getTeamId()}`;
      teamStockRepurchased += `&team_id=${Auth.getTeamId()}`;
    }

    batchRequest([
      teamEquitiesUrl,
      teamStockRepurchased
    ]).then(res => {
      const equitiesLte = res[0].body;
      const stockRepurchasedLte = res[1].body;

      let equitiesIssuanceLte = 0;
      let stockRepurchasedSharesLte = 0;

      if (equitiesLte.length) {
        equitiesLte.forEach(equity => {
          equitiesIssuanceLte += equity.issuance;
        });
      }

      if (stockRepurchasedLte.length) {
        stockRepurchasedLte.forEach(stockRepurchased => {
          stockRepurchasedSharesLte += stockRepurchased.shares;
        });
      }

      this.setState({
        loaded: true,
        equitiesIssuanceLte,
        stockRepurchasedSharesLte
      });
    })
      .catch(err => { });
  }

  formatNumber = (value) => {
    return `${(value / 1000000).toFixed(1)}M`;
  }

  generateBalanceTableKeys = () => {
    const { equitiesIssuanceLte, stockRepurchasedSharesLte } = this.state;
    const { constants } = this.props;

    return (
      [
        {
          group: "Assets",
          rows: [
            { key: "Cash", label: "Cash" },
            { key: "Accounts Receivable", label: "Accounts Receivable" },
            { key: "Inventory", label: "Inventory" },
            { key: "PPE", label: "Property, Plant, & Equipment" },
            { key: "Accumulated Depreciation", label: "Accumulated Depreciation" },
            { key: "Total Assets", label: "Total Assets" }
          ]
        },
        {
          group: "Liabilities",
          rows: [
            { label: "Interest Payable" },
            { key: "Accounts Payable", label: "Accounts Payable" },
            { key: "Short Term Debt", label: "Short Term Debt" },
            { key: "Long Term Debt", label: "Long Term Debt" },
            { key: "Total Liabilities", label: "Total Liabilities" }
          ]
        },
        {
          group: "Equity",
          rows: [
            { label: "Common Stock", withoutValue: true },
            { label: `Issued Shares (${this.formatNumber(equitiesIssuanceLte + constants.initial_shares)})`, key: "Common Stock" },
            { label: `Bought Back Shares (${this.formatNumber(stockRepurchasedSharesLte)})`, key: "Treasury Stock" },
            { label: "Retained Earnings", withoutValue: true },
            { label: "Beginning Balance", key: "Prior Period Retained Earnings" },
            { label: "Net Profits", key: "Net Income" },
            { label: "Dividends" },
            { label: "Additional Paid in Capital" },
            { label: "Total Equity" }
          ]
        }
      ]
    )
  }

  render() {
    const { balanceSheet } = this.props;
    const { loaded } = this.state;

    const balanceTableKeys = this.generateBalanceTableKeys();

    return loaded ? (
      <Wrapper>
        <TwoPanels title1="Balance Sheet" title2="BalanceSheet">
          <fragment>
            <Text>
              This report breaks down your Total Equity, which comprises of your Total
              Assets less any liabilities you owe.
            </Text>
            <FormulaTable
              items={[
                {
                  name: "Assets",
                  highlighted: true,
                  value: moneyFormat(balanceSheet["Total Assets"])
                },
                { name: "-", highlighted: false, value: "" },
                {
                  name: "Liabilities",
                  highlighted: true,
                  value: moneyFormat(balanceSheet["Total Liabilities"])
                },
                { name: "=", highlighted: false, value: "" },
                {
                  name: "Equities",
                  highlighted: true,
                  value: moneyFormat(balanceSheet["Total Equity"])
                }
              ]}
            />
          </fragment>
          <MoneyTable keys={populateKeys(balanceTableKeys, balanceSheet)} />
        </TwoPanels>
      </Wrapper>
    ) : <Wrapper><Loader type="ball-scale-ripple" active /></Wrapper>;
  }
}

export default BalanceSheet;



// WEBPACK FOOTER //
// ./src/components/analysis/BalanceSheet.js